import React from 'react';
import { createPortal } from 'react-dom';
import useIsMobile from './useIsMobile';

const RightCartPortal = ({
    totalCost,
    sheetsCount,
    noCutPieces,
    cutPieces,
    totalCuts,
    cutCost,
    itemCost,
    onAddToCart,
    showCutBlock,
    partCountTotal,
    cutsCountForUI,
    bendDetailsCount,
    mode,
}) => {
    const [isInfoOpen, setIsInfoOpen] = React.useState(false);
    const [notReadyOpen, setNotReadyOpen] = React.useState(false);
    const isMobile = useIsMobile(768);
    const [isOneClickOpen, setIsOneClickOpen] = React.useState(false);
    const [oneClickName, setOneClickName] = React.useState('');
    const [oneClickPhone, setOneClickPhone] = React.useState('');
    const [oneClickAgreed, setOneClickAgreed] = React.useState(false);
    const [oneClickSubmitting, setOneClickSubmitting] = React.useState(false);
    const [oneClickSuccess, setOneClickSuccess] = React.useState(false);

    const formatPhoneMask = (val) => {
        const digits = val.replace(/\D/g, '');
        if (!digits) return '';
        let phone = digits;
        if (phone.startsWith('7') || phone.startsWith('8')) {
            phone = phone.slice(1);
        }
        phone = phone.slice(0, 10);
        
        let res = '+7';
        if (phone.length > 0) res += ' (' + phone.slice(0, 3);
        if (phone.length >= 3) res += ') ' + phone.slice(3, 6);
        if (phone.length >= 6) res += '-' + phone.slice(6, 8);
        if (phone.length >= 8) res += '-' + phone.slice(8, 10);
        return res;
    };

    const handlePhoneChange = (e) => {
        const formatted = formatPhoneMask(e.target.value);
        setOneClickPhone(formatted);
    };

    const buildOrderMessage = () => {
        const lines = [];

        // 1. Проверяем, есть ли на странице настоящие карточки корзины
        const rawItems = document.querySelectorAll('.modern-cart-item');
        const cartItems = Array.from(rawItems).filter(item => {
            const title = item.querySelector('.modern-cart-title')?.textContent?.trim() || '';
            return title.length > 0;
        });

        if (cartItems.length > 0) {
            lines.push('ТОВАРЫ В КОРЗИНЕ:');
            lines.push('');
            cartItems.forEach((item, index) => {
                const titleEl = item.querySelector('.modern-cart-title');
                const qtyInput = item.querySelector('.modern-qty-input');
                const statHintEl = item.querySelector('.modern-stat-qty-hint');
                const priceEl = item.querySelector('.item-calc-price');
                const commentEl = item.querySelector('.modern-porezka-comment-text');
                const porezkaRows = item.querySelectorAll('.modern-porezka-row');

                let title = titleEl ? titleEl.textContent.trim() : `Товар №${index + 1}`;
                let qty = qtyInput ? (qtyInput.value || qtyInput.getAttribute('value') || '1') : '1';
                const hint = statHintEl ? statHintEl.textContent.trim() : '';
                const price = priceEl ? priceEl.textContent.trim() : '';

                let line = `${index + 1}. ${title}`;
                if (qty) line += ` — ${qty} шт.`;
                if (hint) line += ` ${hint}`;
                if (price) line += ` (${price} ₸)`;
                lines.push(line);

                if (porezkaRows && porezkaRows.length > 0) {
                    porezkaRows.forEach(pRow => {
                        const lbl = pRow.querySelector('.modern-porezka-lbl')?.textContent?.trim() || '';
                        const pQty = pRow.querySelector('.modern-porezka-qty')?.textContent?.trim() || '';
                        const pSum = pRow.querySelector('.modern-porezka-sum')?.textContent?.trim() || '';
                        if (lbl || pQty || pSum) {
                            lines.push(`   ${lbl} ${pQty} ${pSum ? `(${pSum})` : ''}`.replace(/\s+/g, ' ').trim());
                        }
                    });
                }

                if (commentEl) {
                    const cleanComment = commentEl.textContent.replace(/\s+/g, ' ').trim();
                    if (cleanComment) {
                        lines.push(`   Порезка/схема: ${cleanComment}`);
                    }
                }
            });

            const totalWeightEl = document.getElementById('calc-total-weight-val') || document.querySelector('.cart-total-weight');
            const totalPriceEl = document.getElementById('calc-total-price-val') || document.querySelector('.cart-total-price');

            let totalWeightText = totalWeightEl ? totalWeightEl.textContent.trim() : '';
            let totalPriceText = totalPriceEl ? totalPriceEl.textContent.trim() : '';

            if (totalWeightText || totalPriceText) {
                lines.push('');
                if (totalWeightText) lines.push(`Общий вес заказа: ${totalWeightText}`);
                if (totalPriceText) lines.push(`Общая стоимость заказа: ${totalPriceText}`);
            }

            return lines.join('\n');
        }

        // 2. Из props калькулятора
        lines.push('ЗАКАЗ ИЗ КАЛЬКУЛЯТОРА ПОРУБКИ/ГИБКИ:');
        lines.push('');

        if (mode) lines.push(`Режим: ${mode === 'bend' ? 'Гибка' : 'Порубка'}`);
        if (partCountTotal) lines.push(`Количество: ${partCountTotal} шт.`);
        if (noCutPieces > 0) lines.push(`Без порезки: ${noCutPieces} шт.`);
        if (cutPieces > 0) lines.push(`С порезкой: ${cutPieces} шт.`);
        if (totalCuts > 0) lines.push(`Кол-во рубок/резов: ${totalCuts}`);
        if (cutsCountForUI > 0) lines.push(`Рубок для расчёта: ${cutsCountForUI}`);
        if (bendDetailsCount > 0) lines.push(`Загибов: ${bendDetailsCount}`);

        lines.push('');
        if (cutCost > 0) lines.push(`Стоимость порезки/услуг: ${parseFloat(cutCost).toLocaleString('ru-RU', {minimumFractionDigits: 2})} ₸`);
        if (itemCost > 0) lines.push(`Стоимость товара: ${parseFloat(itemCost).toLocaleString('ru-RU', {minimumFractionDigits: 2})} ₸`);
        if (totalCost > 0) lines.push(`Общая стоимость: ${parseFloat(totalCost).toLocaleString('ru-RU', {minimumFractionDigits: 2})} ₸`);

        return lines.join('\n');
    };

    const handleOneClickSubmit = async (e) => {
        e.preventDefault();
        if (!oneClickPhone.trim()) {
            alert('Пожалуйста, введите Ваш номер телефона');
            return;
        }
        if (!oneClickAgreed) {
            alert('Необходимо согласие на обработку персональных данных');
            return;
        }
        setOneClickSubmitting(true);
        try {
            const messageContent = buildOrderMessage();

            const formData = new FormData();
            formData.append('subject', 'Быстрый заказ по телефону (Калькулятор)');
            formData.append('name', oneClickName || 'Не указано');
            formData.append('phone', oneClickPhone);
            formData.append('message', messageContent);

            await fetch('/ajax/mail.php', {
                method: 'POST',
                body: formData
            });
            setOneClickSuccess(true);
        } catch (err) {
            console.error('Ошибка отправки быстрого заказа:', err);
            setOneClickSuccess(true);
        } finally {
            setOneClickSubmitting(false);
        }
    };

    const portalNode = document.getElementById('react-cart-portal-target');
    if (!portalNode) return null;

    const handleAddCart = (e) => {
        e.preventDefault();
        if (onAddToCart) onAddToCart();
    };

    const hasCuts = cutCost > 0 || totalCuts > 0;

    // Display total items logic
    const cutSheetsNum = parseFloat(parseFloat(sheetsCount || 0).toFixed(2));
    const noCutSheetsNum = parseFloat(parseFloat(noCutPieces || 0).toFixed(2));
    const totalItems = parseFloat((noCutSheetsNum + cutSheetsNum).toFixed(2));

    const hideClass = '';

    const content = (
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '16px', fontFamily: '"Commissioner", sans-serif', boxSizing: 'border-box', margin: 0, padding: 0 }}>

            {isMobile && showCutBlock ? (
                <div style={{ padding: '16px', margin: '-16px', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ background: 'white', borderRadius: '10px', padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div style={{ fontSize: '14px', fontWeight: 500, color: 'black', marginBottom: '4px' }}>Общая сумма</div>
                                <div style={{ fontSize: '24px', fontWeight: 700, color: 'black' }}>
                                    {parseFloat(totalCost || 0).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₸
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '10px', fontWeight: 500, color: 'black' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.1074 11.625V15.45C13.1074 16.3426 13.1074 16.7889 12.938 17.1298C12.7891 17.4296 12.5514 17.6735 12.2591 17.8263C11.9267 18 11.4917 18 10.6215 18H5.23535C4.36521 18 3.93013 18 3.59777 17.8263C3.30543 17.6735 3.06773 17.4296 2.91878 17.1298C2.74943 16.7889 2.74943 16.3426 2.74943 15.45V7.375M17.2506 7.375V18M2.74943 13.75H13.1074M3.32717 1.93974L1.27745 6.14487C1.07891 6.55219 0.979641 6.75585 1.00349 6.9214C1.0243 7.06596 1.10226 7.19533 1.21899 7.27909C1.35268 7.375 1.57465 7.375 2.01861 7.375H17.9814C18.4254 7.375 18.6474 7.375 18.7811 7.27909C18.8978 7.19533 18.9757 7.06596 18.9965 6.9214C19.0203 6.75585 18.9211 6.55219 18.7226 6.14487L16.6728 1.93974C16.5066 1.59861 16.4234 1.42805 16.2994 1.30343C16.1897 1.19324 16.0575 1.10943 15.9124 1.05807C15.7483 1 15.5623 1 15.1906 1H4.80949C4.43768 1 4.25178 1 4.08765 1.05807C3.94251 1.10943 3.81031 1.19324 3.70063 1.30343C3.57659 1.42805 3.49346 1.59861 3.32717 1.93974Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    Самовывоз — сегодня
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.5 8.63636H1.64286V10.3636H11.5V8.63636Z" fill="black"/>
                                        <path d="M8.21428 4.31818H0V6.04545H8.21428V4.31818Z" fill="black"/>
                                        <path d="M22.9334 9.16007L20.4691 3.11462C20.406 2.95915 20.3007 2.82662 20.1665 2.7335C20.0323 2.64039 19.8751 2.59081 19.7143 2.59091H17.25V0.863636C17.25 0.634585 17.1635 0.414916 17.0094 0.252953C16.8554 0.0909901 16.6464 0 16.4286 0H3.28572V1.72727H15.6071V12.5713C15.2329 12.7998 14.9054 13.1039 14.6434 13.4661C14.3815 13.8284 14.1904 14.2415 14.081 14.6818H8.91899C8.71906 13.8677 8.24359 13.1582 7.5817 12.6863C6.91981 12.2144 6.11695 12.0125 5.3236 12.1184C4.53025 12.2244 3.80089 12.6309 3.27223 13.2618C2.74357 13.8927 2.4519 14.7046 2.4519 15.5454C2.4519 16.3863 2.74357 17.1982 3.27223 17.8291C3.80089 18.46 4.53025 18.8665 5.3236 18.9725C6.11695 19.0784 6.91981 18.8765 7.5817 18.4046C8.24359 17.9327 8.71906 17.2232 8.91899 16.4091H14.081C14.2601 17.1499 14.6689 17.8068 15.2428 18.276C15.8167 18.7452 16.523 18.9999 17.25 18.9999C17.977 18.9999 18.6833 18.7452 19.2572 18.276C19.8311 17.8068 20.2399 17.1499 20.419 16.4091H22.1786C22.3964 16.4091 22.6054 16.3181 22.7594 16.1561C22.9135 15.9942 23 15.7745 23 15.5454V9.5C23 9.38311 22.9773 9.26744 22.9334 9.16007ZM5.75 17.2727C5.42508 17.2727 5.10745 17.1714 4.83728 16.9816C4.56711 16.7918 4.35655 16.5221 4.2322 16.2064C4.10786 15.8908 4.07532 15.5435 4.13871 15.2085C4.2021 14.8734 4.35857 14.5656 4.58833 14.3241C4.81809 14.0825 5.11082 13.918 5.4295 13.8514C5.74818 13.7847 6.0785 13.8189 6.3787 13.9497C6.67889 14.0804 6.93547 14.3018 7.11599 14.5858C7.29651 14.8699 7.39286 15.2038 7.39286 15.5454C7.39236 16.0034 7.21911 16.4424 6.91113 16.7662C6.60314 17.09 6.18556 17.2722 5.75 17.2727ZM17.25 4.31818H19.1728L20.9332 8.63636H17.25V4.31818ZM17.25 17.2727C16.9251 17.2727 16.6074 17.1714 16.3373 16.9816C16.0671 16.7918 15.8565 16.5221 15.7322 16.2064C15.6079 15.8908 15.5753 15.5435 15.6387 15.2085C15.7021 14.8734 15.8586 14.5656 16.0883 14.3241C16.3181 14.0825 16.6108 13.918 16.9295 13.8514C17.2482 13.7847 17.5785 13.8189 17.8787 13.9497C18.1789 14.0804 18.4355 14.3018 18.616 14.5858C18.7965 14.8699 18.8929 15.2038 18.8929 15.5454C18.8924 16.0034 18.7191 16.4424 18.4111 16.7662C18.1031 17.09 17.6856 17.2722 17.25 17.2727ZM21.3571 14.6818H20.419C20.238 13.9421 19.8287 13.2864 19.2552 12.8175C18.6817 12.3487 17.9765 12.0931 17.25 12.0909V10.3636H21.3571V14.6818Z" fill="black"/>
                                    </svg>
                                    Доставка — завтра
                                </div>
                            </div>
                        </div>

                        <button
                            onClick={handleAddCart}
                            style={{ background: '#157BD7', color: 'white', padding: '15px', borderRadius: '10px', fontSize: '14px', fontWeight: 600, border: 'none', width: '100%', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', textTransform: 'uppercase' }}
                        >
                            <svg width="24" height="24" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.4278 24.5034C11.0437 24.5034 11.543 24.0129 11.543 23.4079C11.543 22.8029 11.0437 22.3125 10.4278 22.3125C9.81182 22.3125 9.3125 22.8029 9.3125 23.4079C9.3125 24.0129 9.81182 24.5034 10.4278 24.5034Z" fill="white" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M22.6973 24.5034C23.3132 24.5034 23.8126 24.0129 23.8126 23.4079C23.8126 22.8029 23.3132 22.3125 22.6973 22.3125C22.0814 22.3125 21.582 22.8029 21.582 23.4079C21.582 24.0129 22.0814 24.5034 22.6973 24.5034Z" fill="white" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M1.5 1.5H5.96107L8.94999 16.1679C9.05198 16.6722 9.33131 17.1252 9.7391 17.4477C10.1469 17.7701 10.6571 17.9414 11.1805 17.9315H22.0209C22.5443 17.9414 23.0546 17.7701 23.4624 17.4477C23.8702 17.1252 24.1495 16.6722 24.2515 16.1679L26.0359 6.97718H7.07634" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            ДОБАВИТЬ В КОРЗИНУ
                        </button>

                        <div
                            onClick={() => setNotReadyOpen(!notReadyOpen)}
                            style={{ textAlign: 'center', color: '#5B5B5B', fontSize: '16px', fontWeight: 500, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', cursor: 'pointer', userSelect: 'none' }}
                        >
                            Не готовы заказать? 
                            <svg width="18" height="12" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"
                                style={{ transition: 'transform 0.3s ease', transform: notReadyOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
                            >
                                <path d="M1 7L7 1L13 7" stroke="#5B5B5B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>

                        <div style={{ maxHeight: notReadyOpen ? '200px' : '0px', overflow: 'hidden', transition: 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out', opacity: notReadyOpen ? 1 : 0, display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <button style={{ background: '#E85A29', color: 'white', border: 'none', cursor: 'pointer', padding: '15px', borderRadius: '10px', fontSize: '14px', fontWeight: 600, textTransform: 'uppercase' }}>
                                СВЯЗАТЬСЯ С МЕНЕДЖЕРОМ
                            </button>

                            <button style={{ background: '#E85A29', color: 'white', border: 'none', cursor: 'pointer', padding: '15px', borderRadius: '10px', fontSize: '14px', fontWeight: 600, textTransform: 'uppercase' }}>
                                ПОЛУЧИТЬ КП
                            </button>
                        </div>

                    </div>
                </div>
            ) : (
                <>
                    {/* СВЯЗАТЬСЯ С МЕНЕДЖЕРОМ button */}
                    <button
                        className={hideClass}
                        style={{ boxSizing: 'border-box', margin: 0, width: '100%', height: 'auto', minWidth: 0, whiteSpace: 'normal', padding: '24px', background: 'rgb(232, 90, 41)', borderRadius: '10px', border: 'none', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontSize: '14px', fontWeight: 600, transition: 'opacity 0.2s', fontFamily: 'Commissioner, sans-serif', lineHeight: 'normal', textTransform: 'none', letterSpacing: 'normal', outline: 'none', boxShadow: 'none' }}
                    >
                        СВЯЗАТЬСЯ С МЕНЕДЖЕРОМ
                    </button>

                    {/* 1. Общая сумма */}
                    <div className={hideClass} style={{ width: '100%', border: '1px solid #BCBCBC', borderRadius: '10px', padding: '24px', background: 'white', display: 'flex', flexDirection: 'column', boxSizing: 'border-box', margin: 0 }}>
                        <div style={{ boxSizing: 'border-box', margin: 0, padding: 0, fontSize: '14px', color: 'black', fontWeight: 400, marginBottom: '8px', lineHeight: 'normal' }}>Общая сумма</div>
                        <div style={{ boxSizing: 'border-box', margin: 0, padding: 0, fontSize: '28px', fontWeight: 600, color: 'black', marginBottom: '20px', lineHeight: 'normal' }}>
                            {parseFloat(totalCost || 0).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₸
                        </div>
                        <button
                            onClick={handleAddCart}
                            style={{ boxSizing: 'border-box', margin: 0, padding: '15px 20px', width: '100%', height: 'auto', minWidth: 0, whiteSpace: 'normal', fontSize: '14px', background: '#157BD7', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: 600, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '13px', transition: 'opacity 0.2s', marginBottom: '24px', fontFamily: 'inherit', lineHeight: 'normal', textTransform: 'uppercase', letterSpacing: 'normal', outline: 'none', boxShadow: 'none' }}
                        >
                            <svg style={{ display: 'block', flexShrink: 0 }} width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.4278 24.5034C11.0437 24.5034 11.543 24.0129 11.543 23.4079C11.543 22.8029 11.0437 22.3125 10.4278 22.3125C9.81182 22.3125 9.3125 22.8029 9.3125 23.4079C9.3125 24.0129 9.81182 24.5034 10.4278 24.5034Z" fill="white" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M22.6973 24.5034C23.3132 24.5034 23.8126 24.0129 23.8126 23.4079C23.8126 22.8029 23.3132 22.3125 22.6973 22.3125C22.0814 22.3125 21.582 22.8029 21.582 23.4079C21.582 24.0129 22.0814 24.5034 22.6973 24.5034Z" fill="white" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M1.5 1.5H5.96107L8.94999 16.1679C9.05198 16.6722 9.33131 17.1252 9.7391 17.4477C10.1469 17.7701 10.6571 17.9414 11.1805 17.9315H22.0209C22.5443 17.9414 23.0546 17.7701 23.4624 17.4477C23.8702 17.1252 24.1495 16.6722 24.2515 16.1679L26.0359 6.97718H7.07634" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            ДОБАВИТЬ В КОРЗИНУ
                        </button>
                        <div style={{ boxSizing: 'border-box', display: 'flex', flexDirection: 'column', gap: '16px', margin: 0, padding: 0 }}>
                            <div style={{ boxSizing: 'border-box', margin: 0, padding: 0, display: 'flex', alignItems: 'center', gap: '12px', color: 'black', fontSize: '16px', fontWeight: 400, lineHeight: 'normal' }}>
                                <svg style={{ display: 'block', flexShrink: 0 }} width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.1074 11.625V15.45C13.1074 16.3426 13.1074 16.7889 12.938 17.1298C12.7891 17.4296 12.5514 17.6735 12.2591 17.8263C11.9267 18 11.4917 18 10.6215 18H5.23535C4.36521 18 3.93013 18 3.59777 17.8263C3.30543 17.6735 3.06773 17.4296 2.91878 17.1298C2.74943 16.7889 2.74943 16.3426 2.74943 15.45V7.375M17.2506 7.375V18M2.74943 13.75H13.1074M3.32717 1.93974L1.27745 6.14487C1.07891 6.55219 0.979641 6.75585 1.00349 6.9214C1.0243 7.06596 1.10226 7.19533 1.21899 7.27909C1.35268 7.375 1.57465 7.375 2.01861 7.375H17.9814C18.4254 7.375 18.6474 7.375 18.7811 7.27909C18.8978 7.19533 18.9757 7.06596 18.9965 6.9214C19.0203 6.75585 18.9211 6.55219 18.7226 6.14487L16.6728 1.93974C16.5066 1.59861 16.4234 1.42805 16.2994 1.30343C16.1897 1.19324 16.0575 1.10943 15.9124 1.05807C15.7483 1 15.5623 1 15.1906 1H4.80949C4.43768 1 4.25178 1 4.08765 1.05807C3.94251 1.10943 3.81031 1.19324 3.70063 1.30343C3.57659 1.42805 3.49346 1.59861 3.32717 1.93974Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Самовывоз — сегодня
                            </div>
                            <div style={{ boxSizing: 'border-box', margin: 0, padding: 0, display: 'flex', alignItems: 'center', gap: '12px', color: 'black', fontSize: '16px', fontWeight: 400, lineHeight: 'normal' }}>
                                <svg style={{ display: 'block', flexShrink: 0 }} width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.5 8.63636H1.64286V10.3636H11.5V8.63636Z" fill="black"/>
                                    <path d="M8.21428 4.31818H0V6.04545H8.21428V4.31818Z" fill="black"/>
                                    <path d="M22.9334 9.16007L20.4691 3.11462C20.406 2.95915 20.3007 2.82662 20.1665 2.7335C20.0323 2.64039 19.8751 2.59081 19.7143 2.59091H17.25V0.863636C17.25 0.634585 17.1635 0.414916 17.0094 0.252953C16.8554 0.0909901 16.6464 0 16.4286 0H3.28572V1.72727H15.6071V12.5713C15.2329 12.7998 14.9054 13.1039 14.6434 13.4661C14.3815 13.8284 14.1904 14.2415 14.081 14.6818H8.91899C8.71906 13.8677 8.24359 13.1582 7.5817 12.6863C6.91981 12.2144 6.11695 12.0125 5.3236 12.1184C4.53025 12.2244 3.80089 12.6309 3.27223 13.2618C2.74357 13.8927 2.4519 14.7046 2.4519 15.5454C2.4519 16.3863 2.74357 17.1982 3.27223 17.8291C3.80089 18.46 4.53025 18.8665 5.3236 18.9725C6.11695 19.0784 6.91981 18.8765 7.5817 18.4046C8.24359 17.9327 8.71906 17.2232 8.91899 16.4091H14.081C14.2601 17.1499 14.6689 17.8068 15.2428 18.276C15.8167 18.7452 16.523 18.9999 17.25 18.9999C17.977 18.9999 18.6833 18.7452 19.2572 18.276C19.8311 17.8068 20.2399 17.1499 20.419 16.4091H22.1786C22.3964 16.4091 22.6054 16.3181 22.7594 16.1561C22.9135 15.9942 23 15.7745 23 15.5454V9.5C23 9.38311 22.9773 9.26744 22.9334 9.16007ZM5.75 17.2727C5.42508 17.2727 5.10745 17.1714 4.83728 16.9816C4.56711 16.7918 4.35655 16.5221 4.2322 16.2064C4.10786 15.8908 4.07532 15.5435 4.13871 15.2085C4.2021 14.8734 4.35857 14.5656 4.58833 14.3241C4.81809 14.0825 5.11082 13.918 5.4295 13.8514C5.74818 13.7847 6.0785 13.8189 6.3787 13.9497C6.67889 14.0804 6.93547 14.3018 7.11599 14.5858C7.29651 14.8699 7.39286 15.2038 7.39286 15.5454C7.39236 16.0034 7.21911 16.4424 6.91113 16.7662C6.60314 17.09 6.18556 17.2722 5.75 17.2727ZM17.25 4.31818H19.1728L20.9332 8.63636H17.25V4.31818ZM17.25 17.2727C16.9251 17.2727 16.6074 17.1714 16.3373 16.9816C16.0671 16.7918 15.8565 16.5221 15.7322 16.2064C15.6079 15.8908 15.5753 15.5435 15.6387 15.2085C15.7021 14.8734 15.8586 14.5656 16.0883 14.3241C16.3181 14.0825 16.6108 13.918 16.9295 13.8514C17.2482 13.7847 17.5785 13.8189 17.8787 13.9497C18.1789 14.0804 18.4355 14.3018 18.616 14.5858C18.7965 14.8699 18.8929 15.2038 18.8929 15.5454C18.8924 16.0034 18.7191 16.4424 18.4111 16.7662C18.1031 17.09 17.6856 17.2722 17.25 17.2727ZM21.3571 14.6818H20.419C20.238 13.9421 19.8287 13.2864 19.2552 12.8175C18.6817 12.3487 17.9765 12.0931 17.25 12.0909V10.3636H21.3571V14.6818Z" fill="black"/>
                                </svg>
                                Доставка — завтра
                            </div>
                        </div>
                    </div>

                    {/* 2. Итого */}
                    {showCutBlock && (
                        <div style={{ width: '100%', border: '1px solid #BCBCBC', borderRadius: '10px', padding: '24px', background: 'white', display: 'flex', flexDirection: 'column', boxSizing: 'border-box' }}>
                            
                            <div style={{ fontSize: '14px', fontWeight: 600, color: 'black', textTransform: 'uppercase', marginBottom: '16px', lineHeight: 'normal' }}>
                                ИТОГО
                            </div>

                            <div style={{ fontSize: '14px', fontWeight: 400, color: 'black', marginBottom: '12px', lineHeight: 'normal' }}>
                                Общее количество листов: {totalItems} шт.
                            </div>
                            <div style={{ fontSize: '14px', fontWeight: 400, color: 'black', marginBottom: '12px', lineHeight: 'normal' }}>
                                Без порубки: {noCutSheetsNum} листов
                            </div>
                            <div style={{ fontSize: '14px', fontWeight: 400, color: 'black', marginBottom: '24px', lineHeight: 'normal' }}>
                                С порубкой: {cutSheetsNum} листов
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '24px' }}>
                                <div
                                    onClick={() => setIsInfoOpen(!isInfoOpen)}
                                    style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', cursor: 'pointer', color: 'black', fontSize: '14px', fontWeight: 600, textTransform: 'uppercase', lineHeight: 'normal' }}
                                >
                                    ИНФО
                                    <svg 
                                        width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"
                                        style={{ transition: 'transform 0.2s', transform: isInfoOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
                                    >
                                        <path d="M1 1L7 7L13 1" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                            </div>

                            <div style={{ maxHeight: isInfoOpen ? '500px' : '0px', overflow: 'hidden', transition: 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out', opacity: isInfoOpen ? 1 : 0 }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '24px' }}>
                                    <div style={{ background: '#EDEDED', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
                                        <div style={{ color: 'black', fontSize: '12px', marginBottom: '4px' }}>Кол-во деталей:</div>
                                        <div style={{ color: 'black', fontSize: '16px', fontWeight: 600 }}>{partCountTotal || 0}</div>
                                    </div>
                                    <div style={{ background: '#EDEDED', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
                                        <div style={{ color: 'black', fontSize: '12px', marginBottom: '4px' }}>{mode === 'bend' ? 'Гибов:' : 'Рубов/гибов:'}</div>
                                        <div style={{ color: 'black', fontSize: '16px', fontWeight: 600 }}>{mode === 'bend' ? (bendDetailsCount || 0) : `${cutsCountForUI || 0}/${bendDetailsCount || 0}`}</div>
                                    </div>
                                    <div style={{ background: '#EDEDED', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
                                        <div style={{ color: 'black', fontSize: '12px', marginBottom: '4px' }}>Всего рубов:</div>
                                        <div style={{ color: 'black', fontSize: '16px', fontWeight: 600 }}>{totalCuts}</div>
                                    </div>
                                    <div style={{ background: '#EDEDED', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
                                        <div style={{ color: 'black', fontSize: '12px', marginBottom: '4px' }}>Бесплатных:</div>
                                        <div style={{ color: 'black', fontSize: '16px', fontWeight: 600 }}>0</div>
                                    </div>
                                    <div style={{ background: '#EDEDED', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
                                        <div style={{ color: 'black', fontSize: '12px', marginBottom: '4px' }}>Платных:</div>
                                        <div style={{ color: 'black', fontSize: '16px', fontWeight: 600 }}>{totalCuts}</div>
                                    </div>
                                    <div style={{ background: '#EDEDED', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
                                        <div style={{ color: 'black', fontSize: '12px', marginBottom: '4px' }}>Сумма порубки:</div>
                                        <div style={{ color: 'black', fontSize: '16px', fontWeight: 600 }}>{parseFloat(cutCost || 0).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₸</div>
                                    </div>
                                </div>
                            </div>

                            <div style={{ fontSize: '14px', fontWeight: 600, color: 'black', textTransform: 'uppercase', marginBottom: '8px', lineHeight: 'normal' }}>
                                СТОИМОСТЬ УСЛУГИ
                            </div>
                            <div style={{ fontSize: '28px', fontWeight: 600, color: 'black', marginBottom: '24px', lineHeight: 'normal' }}>
                                {parseFloat(cutCost || 0).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₸
                            </div>

                            <div style={{ fontSize: '14px', fontWeight: 600, color: 'black', textTransform: 'uppercase', marginBottom: '8px', lineHeight: 'normal' }}>
                                СТОИМОСТЬ ТОВАРА
                            </div>
                            <div style={{ fontSize: '28px', fontWeight: 600, color: 'black', lineHeight: 'normal' }}>
                                {parseFloat(itemCost || 0).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₸
                            </div>

                        </div>
                    )}

                    {/* 3. Заказ в 1 клик */}
                    <div 
                        className={hideClass} 
                        onClick={() => { setOneClickSuccess(false); setIsOneClickOpen(true); }}
                        style={{ boxSizing: 'border-box', margin: '8px 0 0 0', padding: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '16px', cursor: 'pointer' }}
                    >
                        <svg style={{ display: 'block', flexShrink: 0 }} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M4.547 12.877C7.71191 16.7452 11.2548 20.2881 15.123 23.453L16.1247 24.2726C17.7849 25.6309 20.2043 25.5103 21.7211 23.9934L24.0634 21.6511L19.6348 17.2225L15.9443 20.913L7.07138 12.0402L10.7742 8.36193L6.34886 3.93657L4.00655 6.27888C2.48974 7.79569 2.36907 10.2151 3.72743 11.8753L4.547 12.877ZM13.3603 25.6074C9.34884 22.3252 5.67476 18.6512 2.39263 14.6397L1.57306 13.638C-0.690871 10.8709 -0.489756 6.83862 2.03827 4.31059L6.34886 0L14.7174 8.3685L11.0145 12.0467L15.9443 16.9765L19.6348 13.2859L28 21.6511L23.6894 25.9617C21.1614 28.4898 17.1291 28.6909 14.362 26.4269L13.3603 25.6074Z" fill="black"/>
                        </svg>
                        <div style={{ boxSizing: 'border-box', margin: 0, padding: 0, color: 'black', fontSize: '16px', fontWeight: 400, lineHeight: 'normal' }}>Заказ в 1 клик</div>
                    </div>

                    {/* Divider */}
                    <div className={hideClass} style={{ boxSizing: 'border-box', height: '1px', background: '#e0e0e0', width: '100%', margin: '12px 0 8px 0', padding: 0 }}></div>

                    {/* 4. Не готовы заказать? */}
                    <div className={hideClass} style={{ boxSizing: 'border-box', margin: '0 0 4px 0', padding: 0, textAlign: 'center', color: '#5B5B5B', fontSize: '16px', fontWeight: 400, lineHeight: 'normal' }}>
                        Не готовы заказать?
                    </div>

                    {/* 5. ПОЛУЧИТЬ КП button */}
                    <button
                        className={hideClass}
                        onClick={() => { setOneClickSuccess(false); setIsOneClickOpen(true); }}
                        style={{ boxSizing: 'border-box', margin: 0, padding: '15px', width: '100%', height: 'auto', minWidth: 0, whiteSpace: 'normal', background: '#E85A29', borderRadius: '10px', border: 'none', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontSize: '12px', fontWeight: 600, transition: 'opacity 0.2s', fontFamily: 'inherit', lineHeight: 'normal', textTransform: 'none', letterSpacing: 'normal', outline: 'none', boxShadow: 'none' }}
                    >
                        ПОЛУЧИТЬ КП
                    </button>
                </>
            )}
            {/* 1-Click Modal Portal */}
            {isOneClickOpen && createPortal(
                <div 
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 999999,
                        padding: '20px',
                        boxSizing: 'border-box'
                    }}
                    onClick={(e) => {
                        if (e.target === e.currentTarget) setIsOneClickOpen(false);
                    }}
                >
                    <div 
                        className="one-click-modal-box"
                        style={{
                            background: '#FFFFFF',
                            borderRadius: '24px',
                            padding: '36px 32px 32px 32px',
                            width: '100%',
                            maxWidth: '440px',
                            position: 'relative',
                            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.2)',
                            boxSizing: 'border-box',
                            fontFamily: 'Commissioner, sans-serif'
                        }}
                        onClick={e => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button 
                            type="button" 
                            className="one-click-close-btn"
                            onClick={() => setIsOneClickOpen(false)}
                            style={{
                                position: 'absolute',
                                top: '20px',
                                right: '20px',
                                width: '36px',
                                height: '36px',
                                borderRadius: '50%',
                                background: '#F0F0F0',
                                border: 'none',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'background 0.2s'
                            }}
                            onMouseOver={e => e.currentTarget.style.background = '#E4E4E4'}
                            onMouseOut={e => e.currentTarget.style.background = '#F0F0F0'}
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#666666" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>

                        {/* Title */}
                        <div style={{
                            color: '#E85A29',
                            fontSize: '24px',
                            fontFamily: 'Commissioner, sans-serif',
                            fontWeight: '700',
                            textTransform: 'uppercase',
                            wordWrap: 'break-word',
                            textAlign: 'center',
                            marginBottom: '24px'
                        }}>
                            БЫСТРЫЙ ЗАКАЗ ПО ТЕЛЕФОНУ
                        </div>

                        {oneClickSuccess ? (
                            <div style={{ textAlign: 'center', padding: '16px 0' }}>
                                <div style={{ fontSize: '18px', fontWeight: '600', color: '#2E7D32', marginBottom: '12px', fontFamily: 'Commissioner, sans-serif' }}>
                                    Спасибо! Заявка принята.
                                </div>
                                <div style={{ fontSize: '14px', color: '#555', marginBottom: '24px', fontFamily: 'Commissioner, sans-serif', lineHeight: '1.4' }}>
                                    Ваша корзина отправлена менеджеру. Мы перезвоним Вам в течение 30 минут и оформим заказ.
                                </div>
                                <button
                                    type="button"
                                    onClick={() => { setIsOneClickOpen(false); setOneClickSuccess(false); }}
                                    style={{
                                        width: '100%', height: '48px', background: '#E85A29', borderRadius: '12px',
                                        border: 'none', color: '#FFFFFF', fontSize: '16px', fontWeight: '600', cursor: 'pointer',
                                        fontFamily: 'Commissioner, sans-serif'
                                    }}
                                >
                                    Закрыть
                                </button>
                            </div>
                        ) : (
                            <form onSubmit={handleOneClickSubmit}>
                                {/* Field 1: ФИО */}
                                <div style={{ marginBottom: '16px' }}>
                                    <label style={{
                                        display: 'block', color: 'black', fontSize: '16px',
                                        fontFamily: 'Commissioner, sans-serif', fontWeight: '500',
                                        wordWrap: 'break-word', marginBottom: '8px'
                                    }}>
                                        ФИО
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Введите имя"
                                        value={oneClickName}
                                        onChange={e => setOneClickName(e.target.value)}
                                        style={{
                                            width: '100%',
                                            height: '50px',
                                            background: '#FFFFFF',
                                            border: '1px solid #E0E0E0',
                                            borderRadius: '10px',
                                            padding: '0 16px',
                                            fontSize: '20px',
                                            fontFamily: 'Commissioner, sans-serif',
                                            fontWeight: '400',
                                            color: 'black',
                                            boxSizing: 'border-box',
                                            outline: 'none'
                                        }}
                                    />
                                </div>

                                {/* Field 2: Телефон* */}
                                <div style={{ marginBottom: '16px' }}>
                                    <label style={{
                                        display: 'block', color: 'black', fontSize: '16px',
                                        fontFamily: 'Commissioner, sans-serif', fontWeight: '500',
                                        wordWrap: 'break-word', marginBottom: '8px'
                                    }}>
                                        Телефон*
                                    </label>
                                    <input
                                        type="tel"
                                        placeholder="+7 (___) - ___ -___"
                                        className="one-click-modal-input"
                                        value={oneClickPhone}
                                        onChange={handlePhoneChange}
                                        required
                                        style={{
                                            width: '100%',
                                            height: '50px',
                                            background: '#FFFFFF',
                                            border: '1px solid #E0E0E0',
                                            borderRadius: '10px',
                                            padding: '0 16px',
                                            fontSize: '20px',
                                            fontFamily: 'Commissioner, sans-serif',
                                            fontWeight: '400',
                                            color: 'black',
                                            boxSizing: 'border-box',
                                            outline: 'none'
                                        }}
                                    />
                                </div>

                                {/* Blue note text */}
                                <div style={{
                                    color: '#3284CF',
                                    fontSize: '14px',
                                    fontFamily: 'Commissioner, sans-serif',
                                    fontWeight: '500',
                                    wordWrap: 'break-word',
                                    marginTop: '12px',
                                    marginBottom: '20px',
                                    lineHeight: '1.4'
                                }}>
                                    Ваша корзина будет отправлена менеджеру, который перезвонит Вам в течении 30 минут и оформит заказ.
                                </div>

                                {/* Submit Button */}
                                <button
                                    type="submit"
                                    disabled={oneClickSubmitting}
                                    className="one-click-submit-btn"
                                    style={{
                                        width: '100%',
                                        height: '52px',
                                        background: '#E85A29',
                                        borderRadius: '12px',
                                        border: 'none',
                                        color: 'white',
                                        fontSize: '18px',
                                        fontFamily: 'Commissioner, sans-serif',
                                        fontWeight: '600',
                                        wordWrap: 'break-word',
                                        cursor: oneClickSubmitting ? 'wait' : 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        transition: 'opacity 0.2s',
                                        marginBottom: '20px',
                                        opacity: oneClickSubmitting ? 0.7 : 1
                                    }}
                                    onMouseOver={e => !oneClickSubmitting && (e.currentTarget.style.opacity = '0.9')}
                                    onMouseOut={e => !oneClickSubmitting && (e.currentTarget.style.opacity = '1')}
                                >
                                    {oneClickSubmitting ? 'Отправка...' : 'Перезвоните мне'}
                                </button>

                                {/* Custom Consent Checkbox */}
                                <div 
                                    onClick={() => setOneClickAgreed(!oneClickAgreed)}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        gap: '12px',
                                        cursor: 'pointer',
                                        userSelect: 'none'
                                    }}
                                >
                                    <div 
                                        style={{
                                            width: '20px',
                                            height: '20px',
                                            borderRadius: '4px',
                                            border: oneClickAgreed ? '1px solid #E85A29' : '1px solid #DFDFDF',
                                            background: oneClickAgreed ? '#E85A29' : '#FFFFFF',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexShrink: 0,
                                            marginTop: '2px',
                                            transition: 'all 0.2s ease',
                                            boxSizing: 'border-box'
                                        }}
                                    >
                                        {oneClickAgreed && (
                                            <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1.5 5L4.5 8L10.5 2" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        )}
                                    </div>
                                    <span style={{
                                        color: 'black',
                                        fontSize: '14px',
                                        fontFamily: 'Commissioner, sans-serif',
                                        fontWeight: '400',
                                        wordWrap: 'break-word',
                                        lineHeight: '1.3'
                                    }}>
                                        Нажимая на кнопку Вы соглашаетесь с {' '}
                                        <a 
                                            href="/politic.pdf" 
                                            target="_blank" 
                                            rel="noreferrer" 
                                            style={{ color: '#E85A29', textDecoration: 'none' }}
                                            onClick={e => e.stopPropagation()}
                                        >
                                            правилами обработки персональных данных
                                        </a>
                                    </span>
                                </div>
                            </form>
                        )}
                    </div>
                </div>,
                document.body
            )}
        </div>
    );

    return createPortal(content, portalNode);
};

export default RightCartPortal;
